import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusPointer extends ToolStylus {
  static toolName = 'Pointer';
  static shortcut = new Shortcut('`');

  static action({ controller }) {
    controller.actionSetStylus(controller.stylusPointer);
  }
}

export default ToolStylusPointer;
